import React from 'react';
import classnames from 'classnames';
import { useAngularService } from 'helpers/get_angular_service';
import Tooltip from './tooltip';

interface ExportButtonProps {
  size?: 'sm';
  type?: 'button' | 'submit';
  variant?: 'table-header';
  onExport?: () => void;
  label?: string;
}

const ExportButton = ({ onExport, size, type = 'button', variant, label }: ExportButtonProps) => {
  const AdminUserService = useAngularService('AdminUserService');

  if (!AdminUserService.has('admin_perform_csv_exports')) return null;

  const onClick = () => {
    if (onExport) {
      onExport();
    }
  };

  if (variant === 'table-header') {
    return (
      <>
        <Tooltip type="light" />
        <button type={type} onClick={onClick} className="export-button" data-tip="Export">
          <i className="icon-download" />
        </button>
      </>
    );
  }

  return (
    <button
      type={type}
      className={classnames('btn btn-default', { 'btn-sm': size === 'sm' })}
      onClick={onClick}
    >
      <span className="hidden-xs">
        <i className="icon-download" />
      </span>{' '}
      {label ? label : 'Export'}
    </button>
  );
};

export default ExportButton;
